import React from "react";
import { X, Edit3, Plus, Tag, Calendar, Maximize2 } from "lucide-react";

const NoteDialog = ({ show, isEditing, formData, setFormData, onSave, onClose, onExpand }) => {
  if (!show) return null;

  return (
    <div className="modal d-block" style={{ backgroundColor: 'rgba(0,0,0,0.4)', backdropFilter: 'blur(4px)', zIndex: 1050 }}>
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content border-0 rounded-4 shadow-lg p-2">
          <div className="modal-header border-0 pb-0">
            <h5 className="fw-bold mb-0">
              {isEditing ? (
                <span className="d-flex align-items-center gap-2"><Edit3 size={20} className="text-primary" /> Notiz bearbeiten</span>
              ) : (
                <span className="d-flex align-items-center gap-2"><Plus size={20} className="text-primary" /> Neue Notiz</span>
              )}
            </h5>
            <div className="d-flex align-items-center gap-2">
              <button className="btn btn-sm btn-outline-primary d-flex align-items-center gap-2 rounded-3 px-3 py-1" onClick={onExpand}>
                <Maximize2 size={14} /> Erweitern
              </button>
              <button className="btn-close" onClick={onClose}></button>
            </div>
          </div>

          <div className="modal-body pt-4">
            <div className="row g-3">
              {/* Title */}
              <div className="col-12">
                <label className="small fw-bold text-muted mb-1 ml-1">Titel</label>
                <input
                  className="form-control border-0 bg-light rounded-3 py-2"
                  placeholder="z.B. Projektideen"
                  value={formData.title}
                  onChange={e => setFormData({ ...formData, title: e.target.value })}
                />
              </div>

              {/* Category */}
              <div className="col-md-6">
                <label className="small fw-bold text-muted mb-1 ml-1">Kategorie</label>
                <div className="input-group">
                  <span className="input-group-text border-0 bg-light rounded-start-3 text-muted px-2"><Tag size={14} /></span>
                  <input
                    className="form-control border-0 bg-light rounded-end-3 py-2"
                    placeholder="Allgemein"
                    value={formData.category}
                    onChange={e => setFormData({ ...formData, category: e.target.value })}
                  />
                </div>
              </div>

              {/* Date */}
              <div className="col-md-6">
                <label className="small fw-bold text-muted mb-1 ml-1">Datum</label>
                <div className="input-group">
                  <span className="input-group-text border-0 bg-light rounded-start-3 text-muted px-2"><Calendar size={14} /></span>
                  <input
                    type="date"
                    className="form-control border-0 bg-light rounded-end-3 py-2"
                    value={formData.noteDate}
                    onChange={e => setFormData({ ...formData, noteDate: e.target.value })}
                  />
                </div>
              </div>

              {/* Pinned Switch */}
              <div className="col-12">
                <div className="form-check form-switch bg-light p-2 rounded-3 px-5 border-0">
                  <input
                    className="form-check-input mt-1"
                    type="checkbox"
                    id="pinSwitch"
                    checked={formData.isGeneral}
                    onChange={e => setFormData({ ...formData, isGeneral: e.target.checked })}
                  />
                  <label className="form-check-label small fw-bold text-muted" htmlFor="pinSwitch">
                    Diese Notiz oben anheften (Wichtig)
                  </label>
                </div>
              </div>

              {/* Content */}
              <div className="col-12">
                <label className="small fw-bold text-muted mb-1 ml-1">Inhalt</label>
                <textarea
                  className="form-control border-0 bg-light rounded-4 py-2"
                  rows="5"
                  placeholder="Inhalt der Notiz..."
                  value={formData.content}
                  onChange={e => setFormData({ ...formData, content: e.target.value })}
                ></textarea>
              </div>
            </div>
          </div>

          <div className="modal-footer border-0 pt-0 pb-3">
            <button className="btn btn-light rounded-3 px-4 fw-medium" onClick={onClose}>
              Abbrechen
            </button>
            <button
              className="btn btn-primary rounded-3 px-4 fw-bold"
              onClick={onSave}
              disabled={!formData.title}
            >
              Speichern
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NoteDialog;